import {EventEmitter, Injectable, Output} from "@angular/core";
@Injectable({
  providedIn: 'root'
})
export class ServiceNotificationService {
  @Output() recibeNotificacion: EventEmitter<any> = new EventEmitter();

  constructor() {}


}

